import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';
import { jsmProjectSettingsUrl } from './common/index.tsx';

export const projectSettingsServicedeskProformaProjectFormsRoute: InvariantRoute = {
	name: 'project-settings-servicedesk-proforma-project-forms',
	path: `${jsmProjectSettingsUrl}/forms`,
	exact: true,
};
